import React, { useState, useEffect } from 'react';
import Button from './Form/Button';
import { Link } from 'react-router-dom';

const textArray = [
  {
    itemNo: '01',
    title: 'Answer a few simple questions',
    content: `Wondering how to get started? It only takes about ten minutes with iWill. Can't find five minutes for yourself? Come back and finish any time.`
  },
  {
    itemNo: '02',
    title: 'Choose a plan',
    content: `Wondering how to get started? It only takes about five minutes with iWill. Can't find five minutes for yourself? Come back and finish any time.`
  },
  {
    itemNo: '03',
    title: 'Create your account',
    content: `Wondering how to get started? It only takes about five minutes with iWill. Can't find five minutes for yourself? Come back and finish any time.`
  },
  {
    itemNo: '04',
    title: 'Assign your asset',
    content: `Wondering how to get started? It only takes about five minutes with iWill. Can't find five minutes for yourself? Come back and finish any time.`
  }
];

const HowItWorkTextAnimate = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentText, setCurrentText] = useState(textArray[0]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % textArray.length);
    }, 1000); // Change text every 2 seconds

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setCurrentText(textArray[currentIndex]);
  }, [currentIndex]);

  return (
    <div className="relative p-4 text-center xsm350:w-[90%] md:mt-20 md:w-[38%] md:text-xl">
      <p className="font-circular  font-bold text-[#FF6600]">
        {currentText.itemNo}
      </p>
      <h2 className="mb-2 text-center font-bold text-[#1E063E] md:text-2xl">
        {currentText.title}
      </h2>
      <span className="mt-5 w-[59%] text-center font-circular text-base font-normal leading-10 text-[#5C6B7E]">
        {currentText.content}
      </span>
      <div className="flex flex-col items-center">
        <Link to="/get-started">
          <Button
            variant="primary"
            size="md"
            className="mt-10 w-[9rem] rounded"
            label="Get Started"
          ></Button>
        </Link>
      </div>
    </div>
  );
};

export default HowItWorkTextAnimate;
